import React from 'react';
import {
  Container as GridContainer,
  Row as GridRow,
  Col as GridCol
} from 'react-grid-system';

export {
  setConfiguration,
  useScreenClass,
  ClearFix,
  Hidden,
  ScreenClassRender,
  Visible,
  ScreenClassProvider,
} from 'react-grid-system';

export const Container = ({ flex, direction, align, justify, bottom, ...props }) => (
  <GridContainer
    {...props}
    style={{
      ...props.style,
      display: flex ? 'flex' : 'block',
      alignItems: align || 'flex-start',
      flexDirection: direction || 'row',
      justifyContent: justify || 'flex-start',
      marginBottom: bottom || 0,
    }}
  />
);

export const Row = ({ bottom, direction, ...props }) => (
  <GridRow
    {...props}
    style={{
      ...props.style,
      flexDirection: direction || 'row',
      marginBottom: bottom || 0,
    }}
  />
);

export const Col = ({ align, bottom, ...props }) => (
  <GridCol
    {...props}
    style={{
      ...props.style,
      marginBottom: bottom || 0,
      textAlign: align || 'left'
    }}
  />
);
